import clsx from 'clsx';
import type { ReactNode, Ref, TextareaHTMLAttributes } from 'react';
import { Field } from './Field.tsx';
import styles from './Input.module.css';

export interface TextAreaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'id' | 'className'> {
  readonly label: string;
  readonly hint?: ReactNode | undefined;
  readonly error?: string | null | undefined;
  readonly aside?: ReactNode | undefined;
  readonly labelHidden?: boolean | undefined;
  readonly className?: string | undefined;
  readonly ref?: Ref<HTMLTextAreaElement> | undefined;
}

export const TextArea = ({
  label,
  hint,
  error,
  aside,
  labelHidden,
  className,
  ...textarea
}: TextAreaProps) => (
  <Field
    label={label}
    hint={hint}
    error={error}
    aside={aside}
    labelHidden={labelHidden}
    className={className}
  >
    {(control) => <textarea className={clsx(styles.control, styles.multiline)} {...control} {...textarea} />}
  </Field>
);
